import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

function Square(props){
    if(props.value === 'W'){
        return(
            <button className="square" onClick={props.onClick}>
                <div className="white"></div>
            </button>
        );
    }else if(props.value === 'B'){
        return(
            <button className="square" onClick={props.onClick}>
                <div className="black"></div>
            </button>
        );
    }else{
        return(
            <button className="square" onClick={props.onClick}>
                {props.value}
            </button>
        );
    }
}

// function checkReverse(squares,i){
//     squares[i] = 'Q';
//     //Board.setState({squares:squares});
//     return squares;
// }

class Board extends React.Component {
    constructor(){
        super();
        this.state = {
            squares: Array(64).fill(null).fill('W',27,28)
            .fill('W',36,37)
            .fill('B',28,29)
            .fill('B',35,36),
            whiteIsNext: true,
        };
    }

    checkReverseByRow(squares,i){
        const current_row = Math.floor(i/8);
        const start_row = current_row*8;
        const end_row = start_row+8;
        //console.log(current_row);
        const ally = this.state.whiteIsNext ? 'W' : 'B';
        const enemy = this.state.whiteIsNext ? 'B' : 'W';

        //Start Check Left -> Right
        for(let point=i+1; point<end_row; point++){
            //Check enemy
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point+1; checkPoint<end_row; checkPoint++){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change<=checkPoint; change++){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }

        for(let point=i-1; point>=start_row; point--){
            //Check enemy
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point-1; checkPoint>=start_row; checkPoint--){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change>=checkPoint; change--){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }
        //console.log("hello");
        //console.log("i : " + i);
        //console.log("Opposite : " + (this.state.whiteIsNext ? 'B' : 'W'));
        
        return null;
    }

    checkReverseByColumn(squares,i){
        
        const current_col = i%8;
        const start_col = current_col;
        const end_col = current_col+(8*7);
        //console.log(i + " : " + current_col + " : " + start_col + " : " + end_col);
        //return null;
        const ally = this.state.whiteIsNext ? 'W' : 'B';
        const enemy = this.state.whiteIsNext ? 'B' : 'W';

        //Start Check Top -> Down
        for(let point=i+8; point<=end_col; point+=8){
            //Check enemy
            //console.log(point);
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point+8; checkPoint<=end_col; checkPoint+=8){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change<=checkPoint; change+=8){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }

        for(let point=i-8; point>=start_col; point-=8){
            //Check enemy
            //console.log(point);
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point-8; checkPoint>=start_col; checkPoint-=8){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change>=checkPoint; change-=8){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }
        return null;
    }
    
    checkReverseByOblique(squares,i){
        
        const current_col = i%8;
        const start_col = current_col;
        const end_col = current_col+(8*7);
        //console.log(i + " : " + current_col + " : " + start_col + " : " + end_col);
        //return null;
        const ally = this.state.whiteIsNext ? 'W' : 'B';
        const enemy = this.state.whiteIsNext ? 'B' : 'W';

        //Start Check TopLeft -> BottomRight
        for(let point=i+9; point<=end_col; point+=9){
            //Check enemy
            //console.log(point);
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point+9; checkPoint<=end_col; checkPoint+=9){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change<=checkPoint; change+=9){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }

        for(let point=i-9; point>=start_col; point-=9){
            //Check enemy
            //console.log(point);
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point-9; checkPoint>=start_col; checkPoint-=9){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change>=checkPoint; change-=9){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }

        //Start Check TopRight -> BottomLeft
        for(let point=i+7; point<=end_col; point+=7){
            //Check enemy
            //console.log(point);
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point+7; checkPoint<=end_col; checkPoint+=7){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change<=checkPoint; change+=7){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }

        for(let point=i-7; point>=start_col; point-=7){
            //Check enemy
            //console.log(point);
            if(squares[point] !== null && squares[point]  === enemy){
                for(let checkPoint=point-7; checkPoint>=start_col; checkPoint-=7){
                    //console.log(squares[checkPoint] + " " + checkPoint);
                    if(squares[checkPoint] !== null){
                        if(squares[checkPoint] === ally){
                            for(let change=point; change>=checkPoint; change-=7){
                                //console.log(change + " " + point + " " + checkPoint);
                                squares[change] = ally;
                                if(change === checkPoint){
                                    this.setState({squares:squares});
                                    break;
                                }
                            }
                        }
                    }else{
                        break;
                    }
                }
            }else{
                break;
            }
        }

        return null;
    }

    isReverse(squares,i){
        //Find Opposite Nearby
        //If found -> Find Ally same direction
        
        const ally = this.state.whiteIsNext ? 'W' : 'B';
        const enemy = this.state.whiteIsNext ? 'B' : 'W';

        /*
        [i-9],[i-8],[i-7]
        [i-1],[i],[i+1]
        [i+7],[i+8],[i+9]
        */
        if(squares[i-9] === enemy){
            if(this.loopFindAlly(squares,i-9,-9,ally)){
                return true
            }
        }
        if(squares[i-8] === enemy){
            if(this.loopFindAlly(squares,i-8,-8,ally)){
                return true
            }
        }
        if(squares[i-7] === enemy){
            if(this.loopFindAlly(squares,i-7,-7,ally)){
                return true
            }
        }
        if(squares[i-1] === enemy){
            if(this.loopFindAlly(squares,i-1,-1,ally)){
                return true
            }
        }
        if(squares[i+1] === enemy){
            if(this.loopFindAlly(squares,i+1,1,ally)){
                return true
            }
        }
        if(squares[i+7] === enemy){
            if(this.loopFindAlly(squares,i+7,7,ally)){
                return true
            }
        }
        if(squares[i+8] === enemy){
            if(this.loopFindAlly(squares,i+8,8,ally)){
                return true
            }
        }
        if(squares[i+9] === enemy){
            if(this.loopFindAlly(squares,i+9,9,ally)){
                return true
            }
        }
        return false
    }

    loopFindAlly(squares,points,direction,ally){
        if(Math.abs(direction) === 1){
            const start_row = Math.floor(points/8)*8;
            const end_row = start_row+8;
            for(let point = points; point >= start_row && point <= end_row; point += direction){
                if(squares[point] === ally){
                    return true
                }
            }
            return false
        }
        for(let point = points; point >= 0 && point <= 63; point += direction){
            if(squares[point] === ally){
                return true
            }
        }
        return false
    }

    handleClick(i){
        //Check is reversed?
        //Allow
        //Reverse

        const squares = this.state.squares.slice();
        
        const isReverse = this.isReverse(squares,i)
        if(squares[i] || !isReverse){
            return;
        }
        squares[i] = this.state.whiteIsNext ? 'W' : 'B';
        this.setState({
            squares: squares,
            whiteIsNext: !this.state.whiteIsNext,
        });

        this.checkReverseByRow(squares,i);
        this.checkReverseByColumn(squares,i);
        this.checkReverseByOblique(squares,i);
    }

    rendersquare(i) {
        return (
            <Square 
            value={this.state.squares[i]}
            onClick={() => this.handleClick(i)}/>
        );
    }

    render(){
        //const winner = calculateWinner(this.state.squares);
        let status;
        const value = this.state.whiteIsNext ? 'White' : 'Black'
           status = 'Next : ' + value;
        return (
            <div className="container">
                <div className="status">{status}</div>
                <div className="board-row">
                    {this.rendersquare(0)}
                    {this.rendersquare(1)}
                    {this.rendersquare(2)}
                    {this.rendersquare(3)}
                    {this.rendersquare(4)}
                    {this.rendersquare(5)}
                    {this.rendersquare(6)}
                    {this.rendersquare(7)}
                </div>
                <div className="board-row">
                    {this.rendersquare(8)}
                    {this.rendersquare(9)}
                    {this.rendersquare(10)}
                    {this.rendersquare(11)}
                    {this.rendersquare(12)}
                    {this.rendersquare(13)}
                    {this.rendersquare(14)}
                    {this.rendersquare(15)}
                </div>
                <div className="board-row">
                    {this.rendersquare(16)}
                    {this.rendersquare(17)}
                    {this.rendersquare(18)}
                    {this.rendersquare(19)}
                    {this.rendersquare(20)}
                    {this.rendersquare(21)}
                    {this.rendersquare(22)}
                    {this.rendersquare(23)}
                </div>
                <div className="board-row">
                    {this.rendersquare(24)}
                    {this.rendersquare(25)}
                    {this.rendersquare(26)}
                    {this.rendersquare(27)}
                    {this.rendersquare(28)}
                    {this.rendersquare(29)}
                    {this.rendersquare(30)}
                    {this.rendersquare(31)}
                </div>
                <div className="board-row">
                    {this.rendersquare(32)}
                    {this.rendersquare(33)}
                    {this.rendersquare(34)}
                    {this.rendersquare(35)}
                    {this.rendersquare(36)}
                    {this.rendersquare(37)}
                    {this.rendersquare(38)}
                    {this.rendersquare(39)}
                </div>
                <div className="board-row">
                    {this.rendersquare(40)}
                    {this.rendersquare(41)}
                    {this.rendersquare(42)}
                    {this.rendersquare(43)}
                    {this.rendersquare(44)}
                    {this.rendersquare(45)}
                    {this.rendersquare(46)}
                    {this.rendersquare(47)}
                </div>
                <div className="board-row">
                    {this.rendersquare(48)}
                    {this.rendersquare(49)}
                    {this.rendersquare(50)}
                    {this.rendersquare(51)}
                    {this.rendersquare(52)}
                    {this.rendersquare(53)}
                    {this.rendersquare(54)}
                    {this.rendersquare(55)}
                </div>
                <div className="board-row">
                    {this.rendersquare(56)}
                    {this.rendersquare(57)}
                    {this.rendersquare(58)}
                    {this.rendersquare(59)}
                    {this.rendersquare(60)}
                    {this.rendersquare(61)}
                    {this.rendersquare(62)}
                    {this.rendersquare(63)}
                </div>
            </div>
        );
    }
}

class Game extends React.Component {
    render(){
        return(
            <div className="game">
                <div className="game-board">
                    <Board />
                </div>
            </div>
        );
    }
}

ReactDOM.render(
  <Game />,
  document.getElementById('root')
);